module.exports = __webpack_public_path__ + "static/media/congaMi.8b830d09.wav";